import { apiService } from './api';
import { ApplyCorrectionRequest, SpeakerCorrectionRecord } from '../types/speakerCorrection';

export async function applySpeakerCorrection(
  encounterId: string,
  body: ApplyCorrectionRequest
): Promise<{ correctionId: string }> {
  return apiService.post<{ correctionId: string }>(
    `/api/v1/encounters/${encounterId}/speaker-corrections`,
    body
  );
}

export async function listSpeakerCorrections(
  encounterId: string
): Promise<SpeakerCorrectionRecord[]> {
  const res = await apiService.get<{ corrections: SpeakerCorrectionRecord[] }>(
    `/api/v1/encounters/${encounterId}/speaker-corrections`
  );
  return res.corrections;
}
